import { useSelector } from "react-redux";
import useEventTracker from "hooks/useEventTracker";
import { TranslationText } from "components/TextTranslationContainer";

function SelectDeliveryAddress({
  children,
  handleAddressClick = () => {},
  containerStyleProps = {},
  headerStyleProps = {},
}) {
  const { orderType } = useSelector((state) => state?.AppReducer);
  useEventTracker({ name: "CHANGE_ADDRESS", shouldLog: true, orderType });

  return (
    <div
      className={`flex flex-col gap-4 ${containerStyleProps?.className ?? "p-4"}`}
      style={containerStyleProps?.style}
    >
      <div
        className={`flex justify-between items-center flex-wrap ${
          headerStyleProps?.className ?? ""
        }`}
        style={headerStyleProps?.style}
      >
        <TranslationText
          text={"Saved Addresses"}
          className={`text-20x font-bold text-shadow-forge-900`}
          as="h2"
        />
        <button onClick={handleAddressClick}>
          <TranslationText
            text={"Add new address"}
            className="text-15x font-bold text-brand-light-base-primary underline hover:text-brand-base-primary"
          />
        </button>
      </div>
      <ul className="overflow-y-auto rounded-t-lg save-address-listing flex flex-col gap-3">
        {children}
      </ul>
    </div>
  );
}

export default SelectDeliveryAddress;
